import Page from "components/Page";
import React, {useEffect, useState} from "react";
import AuditBar from "./components/AuditBar";
import {connect} from "react-redux";
import {withStyles} from "@material-ui/core";
import AuditTaskService from "./service/AuditTaskService";
import Loading from "components/Loading";
import {useParams} from "react-router";
import Tr from "translations/Translations";
import Workspace from "components/Workspace";
import GridBlock from "components/GridBlock";
import TextInput from "components/TextInput";
import Form from 'components/Form';
import { VALUES } from "./constants/AuditTaskStatus";
import validationSchema from "./constants/validationSchema"
import DateTimePicker from "components/DateTimePicker";
import moment from "moment";
import RadioGroup from "components/RadioGroup";
import auditTaskTypes from "./constants/AuditTaskType"
import AuctionTaskUserTable from "./components/AuditTaskUserTable";
import AuditTaskAllowedObjectTable from "./components/AuditTaskAllowedObjectTable";
import NavigationBar from "components/complex/floatingMenu/NavigationBar";
import createButton from "components/complex/floatingMenu/createButton";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import RouterPath, {createPath} from "libs/RouterPath";
import useSnackbar from "../../../hooks/useSnackbar";
import AuditTaskHistoryPopup from "./components/AuditTaskHistoryPopup";

const style = theme => ({
    root: {
        padding: theme.spacing(2)
    },
    form: {
        padding: theme.spacing(1)
    },
    radio: {
        paddingTop: theme.spacing(2)
    },
    tables: {
        paddingTop: theme.spacing(1)
    },
    floatingMenu: {
        position: 'sticky',
        zIndex: theme.zIndex.appBar - 1,
        top: 50,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(2)
    },
});

function AuditTask({
        adminMode = false,
        auditTask,
        classes
    }) {

    const params = useParams();
    const taskId = params.id;

    const [working, setWorking] = useState(false);
    const [historyPopup, setHistoryPopup] = useState(false);
    const {enqueueSuccessSnackbar} = useSnackbar();

    useEffect(() => {
        AuditTaskService.get(taskId, adminMode).then(() => {});

        return () => {
            AuditTaskService.clearTask();
        }
    }, [taskId, adminMode])

    if (!auditTask)
        return <Loading />

    const editable = adminMode && VALUES.FINISHED !== auditTask.status;

    const clearUsers = (formikProps) => {
        formikProps.setFieldValue('auditUsers', [], false);
    }

    const formButtons = (formikProps) => {
        const buttons = [];
        if (adminMode) {
            buttons.push(createButton("save",
                () => formikProps.submitForm(),
                undefined,
                SaveIcon,
                'primary',
                !editable || !Object.keys(formikProps.touched).length || working)
            );
            buttons.push(createButton("cancel",
                () => formikProps.resetForm(),
                'outlined',
                CancelIcon,
                'primary',
                !editable || !Object.keys(formikProps.touched).length || working)
            );
        }
        buttons.push(createButton("back_to_list",
            () => RouterPath.redirect(createPath(adminMode ? RouterPath.audit.AUDIT_LIST_ADMIN : RouterPath.audit.AUDIT_LIST)),
            'outlined',
            null,
            'primary',
            working)
        );
        if (adminMode) {
            buttons.push(createButton("change_history",
                () => setHistoryPopup(true),
                'outlined',
                null,
                'primary',
                auditTask.identity <= 0)
            );
        }
        return buttons;
    }

    const saveAuditTask = (values) => {
        setWorking(true);
        AuditTaskService.saveTask(values).then(resp => {
            setWorking(false);
            if (values.identity <= 0 && resp.result) {
                enqueueSuccessSnackbar(Tr('audit_task_save_success_new'))
            } else {
                enqueueSuccessSnackbar(Tr('audit_task_save_success'))
            }
            RouterPath.redirect(createPath(RouterPath.audit.AUDIT_LIST_ADMIN));
        });
    }

    const backToList = () => {
        RouterPath.redirect(createPath(RouterPath.audit.AUDIT_LIST_ADMIN));
    }

    return (
        <Page floatingWorkspace >
            <AuditBar />
            <Form
                initialValues={{
                    identity: auditTask.identity,
                    name: auditTask.name,
                    startDate: auditTask.startDate ? moment(auditTask.startDate) : null,
                    endDate: auditTask.endDate ? moment(auditTask.endDate) : null,
                    type: auditTask.type,
                    allowedObjects : auditTask.allowedObjects,
                    allowedObjectsCount: {count: auditTask.allowedObjects.length},
                    auditUsers: auditTask.auditUsers,
                    auditUsersCount: {count: auditTask.auditUsers.length}
                }}
                validationSchema={validationSchema(auditTask.status)}
                onSubmit={saveAuditTask}
                onReset={backToList}
            >
                {(formikProps) => {

                    return (<>
                        <div className={classes.floatingMenu}>
                            <NavigationBar buttons={formButtons(formikProps)}/>
                        </div>
                        <Workspace className={classes.root}>
                            <GridBlock
                                column
                                className={classes.form}
                            >
                                <TextInput
                                    id='name'
                                    label={Tr('audit_task_name')}
                                    formikProps={formikProps}
                                    required
                                    disabled={!editable}
                                    limit={400}
                                    showErrorImmediately
                                    multiline
                                />
                                <DateTimePicker
                                    id='startDate'
                                    label={Tr('audit_task_date_start')}
                                    formikProps={formikProps}
                                    minDate={new Date()}
                                    required
                                    disabled={!editable || VALUES.PREPARING !== auditTask.status}
                                />
                                <DateTimePicker
                                    id='endDate'
                                    label={Tr('audit_task_date_end')}
                                    formikProps={formikProps}
                                    minDate={new Date()}
                                    required
                                    disabled={!editable}
                                />
                                <AuditTaskAllowedObjectTable
                                    formikProps={formikProps}
                                    className={classes.tables}
                                    required
                                    editable={editable}
                                />
                                <RadioGroup
                                    id='type'
                                    className={classes.radio}
                                    label={Tr('audit_task_type')}
                                    formikProps={formikProps}
                                    items={auditTaskTypes}
                                    onChange={() => clearUsers(formikProps)}
                                    required
                                    disabled={!editable}
                                />
                                <AuctionTaskUserTable
                                    formikProps={formikProps}
                                    className={classes.tables}
                                    required
                                    editable={editable}
                                />
                            </GridBlock>
                        </Workspace>
                    </>)
                }}
            </Form>
            {!!auditTask.identity && <AuditTaskHistoryPopup
                taskId={auditTask.identity}
                open={historyPopup}
                onClose={() => setHistoryPopup(false)}
            />}
        </Page>
    )
}

export default connect((state) => ({
    auditTask: state.resources.auditTask
}), {})(withStyles(style)(AuditTask));